import { BarChart3, User } from 'lucide-react';
import { useAppSelector } from "@/store/hooks";
import { useEnvVisibility } from '@/hooks/visibility.hook';

export function SidebarFooter({ onResources,isCollapsed }: { onResources: () => void; isCollapsed: boolean }) {
    const user = useAppSelector((s) => s.auth.user);
     const {isQA1, isQA2 } = useEnvVisibility();
  return (
    <div className="mt-4 border-t pt-4 space-y-1">
    { !isQA1 && !isQA2 && <div className="mt-4 border-t pt-4">
        <div
          className={`flex items-center ${isCollapsed ? 'justify-center' : 'gap-3'} px-3 py-2 rounded-md text-sm hover:bg-accent transition-colors cursor-pointer`}
          title={isCollapsed ? 'Analytics' : undefined}
        >
          <BarChart3 className="h-4 w-4" />
          {!isCollapsed && <span>Analytics</span>}
        </div>
      </div>}

      <button
        onClick={onResources}
        className="w-full flex items-center gap-3 px-3 py-2 rounded-md text-sm hover:bg-accent transition-colors cursor-pointer"
      >
        <User className="h-4 w-4" />
       {!isCollapsed && <span>{user?.first_name} {user?.last_name}</span>}
      </button>
    </div>
  
  );
}
